module.exports = __webpack_public_path__ + "media/images/img_matsuno-bfe79c45b59ec5b8b8603ce569f12cff.jpg";